import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Badge, Hidden, IconButton ,Typography, Button, useMediaQuery} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import theme from 'theme';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',backgroundColor:'#b2bec3'
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  },
  TextHeader:{
    marginRight:5,
    color:'white'
  }
}));

const Topbar = props => {
  const { className, onSidebarOpen, ...rest } = props;
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));

  const classes = useStyles();

  const [notifications] = useState([]);

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Toolbar>
        <RouterLink to="/">
          <img
            alt="Logo"
            style={{height:55,marginTop:5}}
            src="/images/3.png"
          />
         
        </RouterLink>
        <Typography variant="h5" className={classes.title,classes.TextHeader}>
      آنـــلاین بــار ایـــران
    </Typography>
        <div className={classes.flexGrow} />
        <Hidden mdDown>
          {/* <IconButton color="inherit">
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton> */}

          <Button
          
          className={classes.signOutButton}
          variant="contained"
          color="white"
          // type="submit"
          href='/sign-in'
          onClick={()=>localStorage.clear()}
          startIcon={<InputIcon style={{marginLeft:10}}  />}
        >
           خروج 
        </Button>
         
          {/* <IconButton
            className={classes.signOutButton}
            color="inherit"
            onClick='/sign-in'
          >
            <InputIcon />
          </IconButton> */}
        </Hidden>
        {isSmall?
          <IconButton href='/sign-in'
          style={{color:'white'}}
          onClick={()=>localStorage.clear()} aria-label="delete" className={classes.margin}>
          <ExitToAppIcon color="white" fontSize="large" />
        </IconButton>
        :""}
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onSidebarOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

export default Topbar;
